import { createSelector } from "reselect";
import get from "lodash/get";
import orderBy from "lodash/orderBy";
import { guestOrderSelector } from "./guestOrder";
import { localeSelector } from "./locale";
import { isEmpty } from "lodash";
// import { failureReasonConstructor } from "utils/helpers";

const portinDonorTelcoDomain = state =>
  get(state, "api.portinDonorTelco.data", []);

const portinRequestDomain = state => get(state, "api.portInRequest.data", {});

export const getDataForMNPConfigDomain = state =>
  get(state, "api.mnpConfig.data", {});
// ***************************************************************
// **************** PORTIN Service selectors *********************
// ***************************************************************

export const portinDonorTelcoSelector = createSelector(
  portinDonorTelcoDomain,
  portinDonorTelco => {
    return orderBy(
      portinDonorTelco
        .filter(telco => telco.enable)
        .map(filteredTelco => ({
          label: filteredTelco?.display_label,
          value: filteredTelco?.name,
          displaySequence: filteredTelco?.display_sequence,
          donorTelcoID: filteredTelco?.DonorTelcoID,
          donorCode: filteredTelco?.code
        })),
      ["label"],
      ["asc"]
    );
  }
);

export const portInNumberTransferFailureReason = createSelector(
  guestOrderSelector,
  localeSelector,
  (order, locale) => {
    // const portFailureReasons = get(
    //   order,
    //   "substates.TELCO_FULFILLMENT.reason",
    //   false
    // );
    // return portFailureReasons
    //   ? failureReasonConstructor(
    //       portFailureReasons,
    //       "portin_failure_end_message",
    //       locale
    //     )
    //   : get(order, "substates.TELCO_FULFILLMENT.status") === "FAILED"
    //   ? "Reach out to our customer service"
    //   : false;
    const portFailureReasons = get(order, "portin_rejection_reason", false);
    let defaultMessage = get(
      locale,
      "portin_failed.portin_failed_reason_default_message",
      "Failed due other reasons. Pls check eligibility by sending sms 'MNP' to 667"
    ); 
    
    if (isEmpty(portFailureReasons)) {
      defaultMessage = ""
    }
    return get(
      locale,
      `portin_failed.${portFailureReasons}`,
      `${defaultMessage}`
    );
  }
);

export const telcoFulfillmentPortInFailureReason = createSelector(
  guestOrderSelector,
  localeSelector,
  order => {
    const portFailureReasons = get(
      order,
      "substates.TELCO_FULFILLMENT.reason",
      false
    );

    return portFailureReasons
      ? portFailureReasons
      : get(order, "substates.TELCO_FULFILLMENT.status") === "FAILED"
      ? "Reach out to our customer service"
      : false;
  }
);

export const getPortInRequest = createSelector(
  portinRequestDomain,
  portInRequest => portInRequest
);

// ***************************************************************
// *************** PORTIN Service makeSelect *********************
// ***************************************************************

export const makeSelectPortinDonorTelco = () => portinDonorTelcoSelector;
export const makeSelectPortInNumberTransferFailureReason = () =>
  portInNumberTransferFailureReason;
export const makeSelectTelcoFulfillmentPortInFailureReason = () =>
  telcoFulfillmentPortInFailureReason;

export const getDataForMNPConfigSelector = createSelector(
  getDataForMNPConfigDomain,
  AddMNPConfigMethodData => AddMNPConfigMethodData
);
export const makeSelectGetMNPConfigSettings = () => getDataForMNPConfigSelector;

export const makeSelectPortInRequest = () => getPortInRequest;
